export const ReportConstants = {
  SECTIONS_ORIGIN_REGISTERED_CLIENT: [
    {label: 'Seleccione una Opción', value: ''},
    {label: 'Regular', value: 'I,R'},
    {label: 'Credit Management', value: 'I,J'},
    {label: 'Credit Control', value: 'I,E'},
    {label: 'Credit Limit', value: 'I,4'},
    {label: 'Prepaid', value: 'I,P'},
    {label: 'Residential', value: 'I,W'},
    {label: 'Employee', value: 'I,S'},
    {label: 'Ready COM', value: 'I,A'},
    {label: 'Update', value: 'I2,4'},
    {label: 'BYOP Credit Limit', value: 'I3,4'},
    {label: 'BYOP Prepaid', value: 'I3,P'}
  ],
  SECTIONS_BUSINESS_REGISTERED_CLIENT: [
    {label: 'Seleccione una Opción', value: ''},
    {label: 'Business / Wireline Misc', value: 'B,MSC'},
    {label: 'Business / Regular', value: 'B,R'},
    {label: 'Business / Corporate', value: 'B,C'},
    {label: 'Business / Ready Com', value: 'B,A'},
    {label: 'Business / Credit Limit', value: 'B,4'},
    {label: 'Business / Prepaid', value: 'B,P'},
    {label: 'Negocio/CreditManagement', value: 'B,J'},
    {label: 'Business/Dealers', value: 'B,D'},
    {label: 'Business / Inmates', value: 'B,INM'},
    {label: 'Business / Wireline Small', value: 'B,SM'},
    {label: 'Business / Wireline Big', value: 'B,BG'},
    {label: 'Government / GSA', value: 'G,GSA'},
    {label: 'Government / Federal', value: 'G,F'},
    {label: 'Government / Local', value: 'G,L'},
    {label: 'Government / Municipality', value: 'G,M'},
    {label: 'Government / Ready Com', value: 'G,A'},
    {label: 'Government / Credit Limit', value: 'G,4'},
    {label: 'Government / Wireline State', value: 'G,L2'},
    {label: 'Government / Wireline Municipality', value: 'G,M2'},
    {label: 'Government / Wireline Public Corp', value: 'G,PC2'},
    {label: 'Government / Wireline Federal', value: 'G,F2'}
  ],
  SECTIONS_WHOLESALE_REGISTERED_CLIENT: [
    {label: 'Seleccione una Opción', value: ''},
    {label: 'WholeSale  Non-Reseller /CLEC Centennial', value: 'H,830'},
    {label: 'WholeSale  Non-Reseller/CLEC LEVEL 3', value: 'H,919'},
    {label: 'WholeSale  Non-Reseller /CLEC WorldNet', value: 'H,972'},
    {label: 'WS Non-Reseller - CMRS/Tariff CLEC', value: 'H,CMR'},
    {label: 'WholeSale  Non-Reseller /Collocation', value: 'H,COL'},
    {label: 'WS Non-Reseller / Contract Tariff COT', value: 'H,COT'},
    {label: 'WholeSale Non-Reseller / CRMS Claro', value: 'H,CRO'},
    {label: 'WholeSale Non-Reseller / ISP', value: 'H,ISP'},
    {label: 'WS Non-Reseller - IXC Carriers', value: 'H,IXC'},
    {label: 'WholeSale  Non-Reseller /Misc', value: 'H,MIS'}
  ],
  ELECTRONIC_BILL_REGISTERED_CLIENT: [
    {label: 'Seleccione una Opción', value: ''},
    {label: 'Y', value: 'Y'},
    {label: 'N', value: 'N'}
  ],
  STATUS_CLIENT_REGISTERED_CLIENT: [
    {name: 'Activos', completed: false, value: 'O'},
    {name: 'Inactivos', completed: false, value: 'N'},
    {name: 'Suspendidos', completed: false, value: 'S'},
    {name: 'Masivos', completed: false, value: 'I'},
  ],
  TYPE_OF_CLIENTS_REGISTERED_CLIENT: [
    {name: 'Corporativo', completed: false, value: 'B'},
    {name: 'Venta al por mayor', completed: false, value: 'H'},
  ],
  SECTION_ORIGIN_CHANGE_PLAN: [
    {label: 'Seleccione', value: ''},
    {label: 'WEB', value: 'WEB'},
    {label: 'MOBILE & APP', value: 'MOBILE'}
  ],
  CONNECTION_STATUS_COLLECTION_PATH: [
    {label: '', value: ''},
    {label: 'Reconectado', value: 'R'},
    {label: 'Suspendido', value: 'S'}
  ],
  STATUS_PAYMENT_COLLECTION_PATH: [
    {label: '', value: ''},
    {label: 'Aprobada', value: 'A'},
    {label: 'Declinada', value: 'D'}
  ],
  STATUS_TRANSACTION_TYPE_COLLECTION_PATH: [
    {label: '', value: ''},
    {label: 'Factura', value: 'Factura'},
    {label: 'Telemercadeo', value: 'Telemercadeo'}
  ],
  SECTIONS_ORIGIN_SALES: [
    {label: 'Seleccione una Opción', value: '0'},
    {label: 'CRM', value: '1'},
    {label: 'WEB', value: '2'},
    {label: 'MOBILE', value: '3'},
    {label: 'CHATBOT', value: '4'}
  ],
  SECTION_STATUS_SALES: [
    {label: 'Seleccione una Opción', value: '0'},
    {label: 'CHARGE', value: '1'},
    {label: 'CREDIT CARD', value: '2'},
    {label: 'FAILED TRANSACTIONS', value: '3'}
  ],
  MONTHS: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  SERVICE_REPORT_SALES: 'https://registro.claropr.com/reports2/',
  SERVICE_REPORT_SALES_ADMIN: 'https://registro.claropr.com/Reports/',
};
